import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    scope: String,
    baseQJson: String,
    errors: Object
  }

  static targets = ["input", "submitBtn", "error", "icon", "label"]

  connect() {
    try {
      this.baseQ =
        this.baseQJsonValue && this.baseQJsonValue.length > 0
          ? JSON.parse(this.baseQJsonValue)
          : {}
    } catch {
      this.baseQ = {}
    }
  }

  async apply() {
    const query = this.inputTarget.value.trim()
    if (!query) return

    this.hideError()
    this.startLoading()

    try {
      const csrf = document.querySelector("meta[name='csrf-token']")?.content || ""
      const res = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": csrf
        },
        body: JSON.stringify({
          query,
          scope: this.scopeValue || undefined,
          base_q: this.baseQ
        })
      })
      if (res.status === 429) {
        this.showError("rate_limit")
        return
      }
      const data = await res.json().catch(() => ({}))
      if (data.ok && data.redirect_url) {
        window.location.assign(data.redirect_url)
        return
      }
      this.showError(data.error)
    } catch {
      this.showError("network")
    } finally {
      this.stopLoading()
    }
  }

  startLoading() {
    if (this.hasSubmitBtnTarget) this.submitBtnTarget.disabled = true
    if (this.hasInputTarget) this.inputTarget.disabled = true
    if (this.hasIconTarget) this.iconTarget.classList.add("animate-pulse")
    if (this.hasLabelTarget) {
      this._originalLabel = this.labelTarget.textContent
      this.labelTarget.textContent = "..."
    }
  }

  stopLoading() {
    if (this.hasSubmitBtnTarget) this.submitBtnTarget.disabled = false
    if (this.hasInputTarget) this.inputTarget.disabled = false
    if (this.hasIconTarget) this.iconTarget.classList.remove("animate-pulse")
    if (this.hasLabelTarget && this._originalLabel) {
      this.labelTarget.textContent = this._originalLabel
    }
  }

  showError(code) {
    if (!this.hasErrorTarget) return
    const map = this.errorsValue || {}
    const text = map[code] || map.unknown || code
    this.errorTarget.textContent = text
    this.errorTarget.classList.remove("hidden")
  }

  hideError() {
    if (!this.hasErrorTarget) return
    this.errorTarget.classList.add("hidden")
    this.errorTarget.textContent = ""
  }
}
